//@ts-check
import Icon from 'components/base/Icon';
import { Tooltip } from '@material-ui/core';
import { LBButton } from '@linearb/buzz';

const DisabledMenu = ({ tooltip }) => {
  return (
    <Tooltip title={tooltip}>
      <LBButton variant='outline' size='icon'>
        <Icon name='MoreHoriz' color='nepal' size='small' />
      </LBButton>
    </Tooltip>
  );
};

export default DisabledMenu;
